var path = 'public/app/partials/modal.html';
var html = "<div class=modal-header>\n  <button type=button class=close data-dismiss=modal aria-hidden=true>×</button>\n  <h3>{{modal.title}}</h3>\n</div>\n<div class=modal-body>\n\n  <div ng-bind-html=modal.body></div>\n\n</div>\n<div class=modal-footer>\n  <button type=button class=\"btn btn-danger\" ng-click=dismiss()>Close</button>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/partials/modal.html
// module id = 619
// module chunks = 5